import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalCoverageAll: [],
  generalCoverage: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalCoverageSlice = createSlice({
  name: "generalCoverage",
  initialState,
  reducers: {
    setGeneralCoverageAll: (state, action) => {
      state.generalCoverageAll = action.payload;
    },
    setGeneralCoverage: (state, action) => {
      state.generalCoverage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralCoverageAll,
  setGeneralCoverage,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalCoverageSlice.actions;

export default generalCoverageSlice.reducer;
